export const NumberForMultiplyingQty = 1000;
export const IN_DC_VALUE = 'IN D/C';
export const OrdersPaneId = 'ordersPane';
export const FixturesPaneId = 'fixturesPane';
export const MultiPaneId = 'multiPane';
